import Baker_PastryCook from "./baker-pastry_cook.svg?react";
import Bartender_Barback from "./bartender-barback-event_bartender.svg?react";
import ChickFilA from "./chick-fil-a.svg?react";
import Dishwasher from "./dishwasher.svg?react";
import FOHSupport_Server from "./foh_support-server.svg?react";
import Housekeeping from "./housekeeping.svg?react";
import LineCook_EventCook from "./line_cook-event_cook.svg?react";
import Maintenance from "./maintenance.svg?react";
import McDonalds from "./mcdonalds.svg?react";
import PrepCook from "./prep_cook.svg?react";

type Certification = keyof typeof iconLookup;

type CertificationBadgeProps = {
  certification: Certification;
  isSkillCertification: boolean;
};

const iconLookup = {
  "Baker/Pastry Cook": Baker_PastryCook,
  "Line Cook": LineCook_EventCook,
  "Event Cook": LineCook_EventCook,
  "Banquet Cook": LineCook_EventCook,
  "Prep Cook": PrepCook,
  "FOH Support": FOHSupport_Server,
  "Team Captain": FOHSupport_Server,
  "Server Assistant": FOHSupport_Server,
  "Event Server": FOHSupport_Server,
  "Banquet Server": FOHSupport_Server,
  "Bartender - Fixed Menu": Bartender_Barback,
  "Bartender - Beer and Wine": Bartender_Barback,
  "Beer & Wine Bartender": Bartender_Barback,
  "Bartender - Full Service Bar": Bartender_Barback,
  Barista: Bartender_Barback,
  Bartender: Bartender_Barback,
  Barback: Bartender_Barback,
  Dishwasher,
  Housekeeping,
  Maintenance,
  "McDonald's Certified": McDonalds,
  "Chick-fil-A Certified": ChickFilA,
} as const;

export function isSupportedCertification(certification: string): certification is Certification {
  return certification in iconLookup;
}

export function CertificationBadge({ certification, isSkillCertification }: Readonly<CertificationBadgeProps>) {
  const Icon = iconLookup[certification];
  if (!Icon) return null;
  return (
    <div className="flex w-fit items-center gap-1 rounded-full border border-light-gray px-1.5 py-0.5 text-small font-semibold">
      <Icon className="size-4" />
      {isSkillCertification && "Certified "}
      {certification}
    </div>
  );
}
